// new sidebar js

  $(document).ready(function() {
  $('.toggle-menu').on('click', function() {
    // Check if the menu is already open
    if (!$('.multi-level-menu-wrapper').hasClass('menu-open')) {
      // Slide the menu in from the left
      $('.multi-level-menu-wrapper').css({display: 'block', left: '-100%'}).animate({left: '0%'}, 500, function() {
        // Add a class to indicate the menu is open
        $(this).addClass('menu-open');
      });
    }
  });

  $('.btn__close').on('click', function() {
    // Slide the menu out to the left
    $('.multi-level-menu-wrapper').animate({left: '-100%'}, 500, function() {
      // Hide the menu after animation and remove the open class
      $(this).css('display', 'none').removeClass('menu-open');
    });
  });
});



$(document).ready(function() {
  // Function to update the visibility of "Show More" and "Show Less" buttons
  function updateButtons($ul) {
    var $items = $ul.find('li');
    var $showMore = $ul.siblings('.show-more');
    var $showLess = $ul.siblings('.show-less');

    if ($items.length > 4) {
      if ($items.filter(':visible').length > 4) {
        $showMore.hide();
        $showLess.show();
      } else {
        $showMore.show();
        $showLess.hide();
      }
    } else {
      $showMore.hide();
      $showLess.hide();
    }
  }

  // Function to toggle items visibility and update button states
  function toggleItems($ul, showMore) {
    var $items = $ul.find('li');
    if (showMore) {
      $items.slice(4).slideDown(function() {
        updateButtons($ul); // Update buttons after items are shown
      });
    } else {
      $items.slice(4).slideUp(function() {
        updateButtons($ul); // Update buttons after items are hidden
      });
    }
  }

  // Initially hide items after the third one and update buttons
  $('.multi-level-menu-wrapper .mainMenu ul').each(function() {
    var $ul = $(this);
    var $items = $ul.find('li');
    if ($items.length > 4) {
      $items.slice(4).hide(); // Hide items beyond the third
    }
    updateButtons($ul); // Set the initial state of buttons
  });

  // Event handler for "Show More" button
  $(document).on('click', '.show-more', function() {
    var $button = $(this);
    var target = $button.data('target');
    var $ul = $(target);

    toggleItems($ul, true); // Show more items
  });

  // Event handler for "Show Less" button
  $(document).on('click', '.show-less', function() {
    var $button = $(this);
    var target = $button.data('target');
    var $ul = $(target);

    toggleItems($ul, false); // Show fewer items
  });
});

$(document).ready(function(){
  $(".multi-level-menu-wrapper").each(function(index,mlMenu){
    var subMenuItems = $(mlMenu).find(".hasSubMenu");
    console.log("subMenuItems", subMenuItems)
    
    subMenuItems.each(function(i,subMenu){
      $(subMenu).find(".trigger").on("click",function(){
       var target=$(subMenu).attr("data-target");
       $(target).addClass("active");
     });
    });
    
    $(".backTrigger").on("click",function(){
      var _backTrigger = this;
      $(_backTrigger).parent(".subMenu").removeClass("active");
    });
    
  });
});
